import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './store/Store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import esES from 'antd/lib/locale-provider/es_ES';
import { ConfigProvider } from 'antd';
import moment from 'moment';
import localization from 'moment/locale/es';
import interceptor from './config/Interceptor';
import 'react-app-polyfill/ie11';
import { ErrorBoundary } from 'react-error-boundary'
import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';

moment.locale('es', localization);
interceptor();
ReactDOM.render(
    <ConfigProvider locale={esES}>
        <Provider store={store}>
            <ErrorBoundary>
                <ClearBrowserCacheBoundary auto fallback='Cargando...' duration={60000} filename={process.env.REACT_APP_FILENAME_META}>
                    <App />
                </ClearBrowserCacheBoundary>
            </ErrorBoundary>
        </Provider>
    </ConfigProvider>
    ,
    document.getElementById('root')
);
registerServiceWorker();
unregister();